import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import back from '../../../asset/img/back.png';
import { useNavigate } from 'react-router-dom';
import bk from '../../../asset/img/foodBk.png';

const CoinRecord = () => {
    let navigate = useNavigate();
    const [coin, setCoin] = useState(0);
    const [coinRecord, setCoinRecord] = useState([{
        name: '豆豆',
        coin: 'ss',
        time: '9'
    }, {
        name: '豆豆',
        coin: 'ss',
        time: '9'
    }, {
        name: '豆豆',
        coin: 'ss',
        time: '9'
    }]);
    const handleBack = () => {
        navigate(`/foodList`);
    };

    return (
        <div className='coinRecord-container'>
            {/* <img src={bk} className="coinRecord-bk" /> */}
          
            <div className='coinRecord-content'>
                {coinRecord.map((item, index) => {
                    return <div className='item'>
                        <div className='top'>
                            <div className='name'>{item.name}</div>
                            <div className='coin'>{item.coin}</div>
                        </div>
                        <div className='time'>{item.time}</div>
                    </div>
                })}
            </div>
            <img src={back} className='coinRecord-back' onClick={handleBack} />
        </div >
    );
};

export default CoinRecord; 